import React from 'react';
import { Model } from "@singularsystems/neo-core";
import { Neo, NeoGrid } from "@singularsystems/neo-react";
import { CatalogueEntry } from "../CatologueEntry"
import DataCache from "../../StaticData/StaticDataCache";
import { IGeneralApiClient } from "../../../Common/ApiClients/GeneralApiClient";
import { Catalogue } from "@singularsystems/neo-react-services";
import * as Roles from "../../../AccessControl/Models/Commands/Security/Roles"
import { TextConstants } from '../../../Common/TextConstants';
import DestinationFieldLookup from '../../GenericMappings/Models/Lookups/DestinationFieldLookup';

export default class DestinationFieldCatalogueEntry extends CatalogueEntry<DestinationFieldLookup> {

    constructor() {
        super("Destination Fields", DestinationFieldLookup);
    }

    public get editRole() {
        return Roles.CatalogueRoles.Edit;
    }

    public getCacheEntry(cache: DataCache) {
        return cache.destinationFields;
    }
    
    public getSaveEndpoint(apiClient: IGeneralApiClient) {
        return apiClient.saveDestinationFieldList;
    }
    
    public renderRow(item: DestinationFieldLookup, meta: Model.TransformMetaType<DestinationFieldLookup>) {
        return (
            <NeoGrid.RowGroup>
                <NeoGrid.Row>
                    <NeoGrid.Column display={meta.destinationTableName} />
                    <NeoGrid.Column display={meta.destinationFieldName} />
                    <Catalogue.ButtonColumn />               
                </NeoGrid.Row>
            </NeoGrid.RowGroup>
        )
    }

    public renderFormControls(item: DestinationFieldLookup, meta: Model.TransformMetaType<DestinationFieldLookup>) {
        this.dataCache.destinationTables.get();
        return <div>
            <Neo.FormGroup label={TextConstants.Labels.DestinationTable}
                                            bind={meta.destinationTableId}
                                            select={{ items: this.dataCache.destinationTables.currentData, displayMember: "destinationTableName", valueMember: "destinationTableId" }} >
                
            </Neo.FormGroup>
            <Neo.FormGroup bind={meta.destinationFieldName}>                
            </Neo.FormGroup>
        </div>
    }
}